'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.SellerCatalogsRemote = undefined;

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _helpers = require('./helpers');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var transformResponse = function transformResponse(response) {
    if (!response || !response.payload || !response.payload.previews) {
        return { data: {} };
    }

    var catalogPreviews = (0, _keys2.default)(response.payload.previews).map(function (id) {
        var _response$payload$pre = response.payload.previews[id],
            catalogId = _response$payload$pre.catalogId,
            countryCode = _response$payload$pre.countryCode,
            description = _response$payload$pre.description,
            sellerId = _response$payload$pre.houseId,
            imagePath = _response$payload$pre.imagePath,
            lastModified = _response$payload$pre.lastModified,
            manuallyRemoved = _response$payload$pre.manuallyRemoved,
            previewId = _response$payload$pre.previewId,
            saleStartTs = _response$payload$pre.saleStart,
            title = _response$payload$pre.title;


        return {
            catalogId: catalogId,
            countryCode: countryCode,
            description: description,
            imagePath: imagePath,
            lastModified: lastModified,
            manuallyRemoved: manuallyRemoved,
            previewId: previewId,
            saleStartTs: saleStartTs,
            sellerId: sellerId,
            title: title
        };
    });

    return {
        data: {
            catalogPreviews: catalogPreviews
        }
    };
};

var SellerCatalogsRemote = exports.SellerCatalogsRemote = {
    fetchSellerEndedCatalogsById: function fetchSellerEndedCatalogsById(_ref) {
        var authToken = _ref.authToken,
            count = _ref.count,
            deployment = _ref.deployment,
            page = _ref.page,
            sellerId = _ref.sellerId,
            sortTerm = _ref.sortTerm;
        return new _promise2.default(function (resolve, reject) {
            var query = {};
            var request = (0, _helpers.makeGet)({ authToken: authToken, deployment: deployment, path: '<ITEM-API>spa/small/seller/' + sellerId + '/recent' });
            if (global.__SERVER__) {
                query.pageSize = count;
                query.cursor = (page - 1) * count;
                query.sortTerm = sortTerm;
            }
            request.query(query);
            request.end(function (err, response) {
                return (0, _helpers.handleResponse)({ err: err, reject: reject, resolve: resolve, response: response });
            });
        });
    },
    fetchSellerPreviewCatalogsById: function fetchSellerPreviewCatalogsById(_ref2) {
        var authToken = _ref2.authToken,
            deployment = _ref2.deployment,
            sellerId = _ref2.sellerId;
        return new _promise2.default(function (resolve, reject) {
            var request = (0, _helpers.makePost)({ apiPath: 'previews', authToken: authToken, deployment: deployment, path: '<CATALOG-PREVIEWS-API>' });
            request.send({ houseId: sellerId });
            request.end(function (err, response) {
                return (0, _helpers.handleResponse)({
                    err: err,
                    reject: reject,
                    resolve: resolve,
                    response: response,
                    transform: transformResponse
                });
            });
        });
    },
    fetchSellerUpcomingCatalogsById: function fetchSellerUpcomingCatalogsById(_ref3) {
        var authToken = _ref3.authToken,
            deployment = _ref3.deployment,
            sellerId = _ref3.sellerId;
        return new _promise2.default(function (resolve, reject) {
            var request = (0, _helpers.makeGet)({ authToken: authToken, deployment: deployment, path: '<ITEM-API>spa/small/seller/' + sellerId + '/upcoming' });
            request.end(function (err, response) {
                return (0, _helpers.handleResponse)({ err: err, reject: reject, resolve: resolve, response: response });
            });
        });
    }
};


//////////////////
// WEBPACK FOOTER
// ./src/redux/api/remote/sellerCatalogs.js
// module id = rdp+
// module chunks = 60